import React from "react";
import Button from "./Buttons/Button.js";
import AppModalCard from "./shared/AppModalCard.js";
import AppModalShell from "./shared/AppModalShell.js";

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "default" | "danger";
  zIndexClassName?: string;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  variant = "default",
  zIndexClassName,
  onConfirm,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <AppModalShell onBackdropClick={onClose} {...(zIndexClassName ? { zIndexClassName } : {})}>
      <AppModalCard title={title} panelClassName="p-6">
        <h2 className="text-lg font-bold text-my-black mb-2">{title}</h2>
        <div className="text-sm text-gray-600 mb-6">{message}</div>
        <div className="flex gap-3">
          <Button type="button" onClick={onClose} variant="secondary" size="lg" className="flex-1">
            {cancelLabel}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            variant={variant === "danger" ? "danger" : "primary"}
            size="lg"
            className={variant === "default" ? "flex-1 bg-golden text-my-black hover:bg-golden/90" : "flex-1"}
          >
            {confirmLabel}
          </Button>
        </div>
      </AppModalCard>
    </AppModalShell>
  );
};

export default ConfirmModal;
